export default {
  methods: {
    getSummaries(param) {
      const sumFlag = ['area'];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else {
          if (sumFlag.includes(column.property)) {
            let sum = 0;
            data.forEach(item => {
              sum += Number(item[column.property]);
            });
            sums[index] = sum;
          } else {
            sums[index] = '';
          }
        }
      });
      return sums;
    }
  }
};
